import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import damIcon from "~/assets/img/dam_marker.svg";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

function createDamLayer(drawing?: boolean): Return {
  const source = new VectorSource();
  const title = drawing ? LayerTitle.DamsDraw : LayerTitle.Dams;
  const icon = `${window.location.origin}${damIcon}`;
  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: () => {
      return drawing
        ? new Style({
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: "#F39C12",
              }),
              stroke: new Stroke({
                color: "#000",
                width: 1,
              }),
            }),
          })
        : new Style({
            image: new Icon({
              opacity: 1,
              src: icon,
              scale: 1.5,
              offset: [0, 0],
              anchor: [0.5, 24],
              anchorXUnits: IconAnchorUnits.FRACTION,
              anchorYUnits: IconAnchorUnits.PIXELS,
            }),
          });
    },
  });
  layer.set("title", title);

  return { source, layer };
}

export default createDamLayer;
